export default __webpack_public_path__ + "static/media/remote.0e71a63b.png";